var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentroDeAtencion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Background",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:url(#New_Gradient_Swatch_1);fill-rule:evenodd;}.cls-2{fill:#bcbec0;opacity:.1;}.cls-3{fill:#fff;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 43.93,
    y1: 69.03,
    x2: 66.86,
    y2: 69.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6a4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79340"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.96 90 111.96 30 60 0 8.04 30 8.04 90 60 120 111.96 90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m97.9,89.04H26.01c-3.04,0-5.51-2.47-5.51-5.5v-47.08c0-3.04,2.47-5.5,5.51-5.5h54.94c3.03,0,5.5,2.47,5.5,5.5v38.01c5.41,5.01,12.47,11.76,12.54,11.83.47.45.62,1.14.38,1.75-.24.61-.83,1-1.48,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m97.9,89.04H26.01c-3.04,0-5.51-2.47-5.51-5.5v-47.08c0-3.04,2.47-5.5,5.51-5.5h54.94c3.03,0,5.5,2.47,5.5,5.5v38.01c5.41,5.01,12.47,11.76,12.54,11.83.47.45.62,1.14.38,1.75-.24.61-.83,1-1.48,1ZM26.01,34.15c-1.27,0-2.31,1.04-2.31,2.31v47.08c0,1.27,1.04,2.31,2.31,2.31h67.89c-2.7-2.56-6.79-6.44-10.13-9.51-.33-.3-.51-.73-.51-1.17v-38.71c0-1.27-1.04-2.31-2.31-2.31H26.01Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.86,64.82c-1.57,5.01-6.21,8.42-11.46,8.42s-9.89-3.41-11.46-8.42h22.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m47.46,50.76h-1.85c-.88,0-1.6-.71-1.6-1.6s.71-1.6,1.6-1.6h1.85c.88,0,1.6.71,1.6,1.6s-.71,1.6-1.6,1.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m59.63,50.76h-1.85c-.88,0-1.6-.71-1.6-1.6s.71-1.6,1.6-1.6h1.85c.88,0,1.6.71,1.6,1.6s-.71,1.6-1.6,1.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m52.62,75.33c-8.4,0-15.33-6.3-16.12-14.66-.04-.45.11-.89.41-1.23.3-.33.73-.52,1.18-.52h29.07c.45,0,.88.19,1.18.52.3.33.45.78.41,1.23-.79,8.36-7.72,14.66-16.13,14.66Zm-12.66-13.21c1.35,5.82,6.52,10.02,12.66,10.02s11.31-4.2,12.66-10.02h-25.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentroDeAtencion);
export default __webpack_public_path__ + "static/media/centro-de-atencion.acda5b300695dccc603d5d96e3f248e9.svg";
export { ForwardRef as ReactComponent };